module.exports = __webpack_public_path__ + "img/encina-full.f0cfd4f1.png";